<template>
  <v-tooltip right>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        x-small
        color="secondary"
        class="copy-icon ml-1"
        @click.stop="onCopy"
        >mdi-content-copy</v-icon
      >
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    tooltip: 'Copy',
    timer: null,
  }),
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer)
  },
  methods: {
    onCopy() {
      navigator.clipboard.writeText(this.value).then(() => {
        this.tooltip = 'Copied!'
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.tooltip = 'Copy'
        }, 1500)
      })
    },
  },
}
</script>

<style scoped>
.copy-icon {
  opacity: 0.4;
  cursor: pointer;
  vertical-align: middle;
}
.copy-icon:hover {
  opacity: 1;
}
</style>
